import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router';
import classNames from 'classnames';
import get from 'lodash/get';
import { components } from 'react-select';
import isFuture from 'date-fns/is_future';

import SpinnerLoader from 'rebook/apps/base/components/SpinnerLoader';
import fetchQuery from 'rebook/apps/utils/fetchQuery';
import BookCover from 'rebook/apps/books/components/BookCover';
import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';
import pluralize from 'rebook/apps/utils/text/pluralize';
import {
  BookmarkIcon, FlagIcon, ReadingIcon,
  AudioIcon, UploadingIcon, AllBooksIcon,
  LockedBooksIcon,
} from 'rebook/apps/base/components/icons/BookIcon';
import { Book } from 'rebook/apps/books/models';
import { URLS } from 'rebook/apps/base/constants';
import UserBookshelvesList from 'rebook/apps/books/views/BookDetailView/BookDetailUserBookshelves/UserBookshelvesList/';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import Select from 'rebook/apps/base/components/Select';
import Button from 'rebook/apps/base/components/Button';
import NewShelveDialog from 'rebook/apps/books/components/NewShelveDialog';
import ModalDialog from 'rebook/mybook/App/ModalDialogs/ModalDialog';

import StarIcon from './images/icons';

import styles from './style.scss';
import UserProfileViewBooks from './UserProfileViewBooks';
import UserProfileViewBooksEmpty from './UserProfileViewBooksEmpty';


let TEXT_BOOKS_FILTER = [
  { value: 0, label: 'Все', icon: AllBooksIcon, textValue: 'all' },
  { value: 1, label: 'Хочу прочитать', icon: BookmarkIcon, textValue: 'wishlist' },
  { value: 2, label: 'Читаю', icon: ReadingIcon, textValue: 'reading' },
  { value: 3, label: 'Прочитано', icon: FlagIcon, textValue: 'read' },
  { value: 4, label: 'Загрузки', icon: UploadingIcon, textValue: 'uploads' },
  { value: 5, label: 'Успейте прочитать', icon: LockedBooksIcon, textValue: 'have_time_to_read' },
];

const AUDIO_BOOKS_FILTER = [
  { value: 0, type: 'all', label: 'Все', icon: AllBooksIcon, textValue: 'all' },
  { value: 1, type: '', label: 'Хочу прослушать', icon: BookmarkIcon, textValue: 'wishlist' },
  { value: 2, type: 'free', label: 'Слушаю', icon: AudioIcon, textValue: 'reading' },
  { value: 3, type: 'standard', label: 'Прослушано', icon: FlagIcon, textValue: 'read' },
  {
    value: 5, type: 'have_time_to_read', label: 'Успейте прослушать',
    icon: LockedBooksIcon, textValue: 'have_time_to_read',
  },
];

export const StatusOption = (props) => {
  return (
    <components.Option {...props} >
      <div className={styles.optionTextContainer}>
        {get(props, 'data.icon', null)
          ? <props.data.icon className={styles.selectIcon} />
          : <BookmarkIcon className={styles.selectIcon} />
        }
        <span>{props.data.label}</span>
      </div>
    </components.Option>
  );
};

export const StatusValueContainer = (props) => {
  return (
    <div className={styles.valueTextContainer}>
      {get(props, 'selectProps.value.icon', null)
        ? <props.selectProps.value.icon className={styles.selectIcon} />
        : <BookmarkIcon className={styles.selectIcon} />
      }
      <components.ValueContainer {...props} />
    </div>
  );
};

class UserProfileView extends React.Component {
  constructor(props) {
    super(props);
    const isExistUploadedBooks = get(props, 'user.uploads_count', 0) > 0;
    if (!isExistUploadedBooks) {
      TEXT_BOOKS_FILTER = TEXT_BOOKS_FILTER.filter((item) => {
        return item.value !== 4;
      });
    }
    this.state = {
      userId: parseInt(this.props.match.params.userId, 10),
      totalBooksCounter: 0,
      counters: {},
      latestBooks: null,
      selectedStatus: 0,
      selectedType: 'text',
      bookshelves: [],
      isExistUploadedBooks,
      haveBooksAvailableForUserOnly: false,
      modalWindow: false,
    };
    this.closeModalWindow = this.closeModalWindow.bind(this);
    this.openModalWindow = this.openModalWindow.bind(this);
    /**
     * чтобы предотвратить вызов setState после редиректа из-за того что ответ от апи
     * приходит позже - используем флаг, который показывает
     * что компонент уже не следует обновлять
     */
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.state.userId) {
      this.props.SeoActions.setData({
        canonicalUrl: `https://${BASE_HOST}/profile/${this.state.userId}/`,
        title: 'Мои книги в электронной библиотеке MyBook',
      });
      this.fetchCounters(this.state.userId);
      this.fetchLatestBookshelves(this.state.userId);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchCounters(userId) {
    const url = `/api/stat/bookuserlist/bystatus/?user=${userId}`;
    let latestBooks = [];
    let haveBooksAvailableForUserOnly = false;
    return fetchQuery(url, { apiVersion: 6 })
      .then(async (data) => {
        const stats = get(data, 'resp.json', null);
        if (stats) {
          let totalBooksCounter = 0;
          for (let key in stats) {
            for (let innerKey in stats[key]) {
              totalBooksCounter += stats[key][innerKey];
            }
          }
          if (totalBooksCounter > 0) {
            await this.fetchLatestUserBooks(userId)
              .then(({ data }) => {
                latestBooks = data.objects;
              });
          }

          if (this._isMounted) {
            let counters = get(data, 'resp.json', {});
            let allBooksCounter = 0;
            let allAudiobooksCounter = 0;

            // считаем сумму со всех счетчиков, кроме have_time_to_read
            for (let value of Object.values({ ...counters.text, have_time_to_read: 0 })) {
              allBooksCounter += value;
            }

            for (let value of Object.values({ ...counters.audio, have_time_to_read: 0 })) {
              allAudiobooksCounter += value;
            }

            counters.text = { ...counters.text, all: allBooksCounter };
            counters.audio = { ...counters.audio, all: allAudiobooksCounter };

            const isExistUserAvailableBook = latestBooks.find((item) => {
              return !!(get(item, 'book.available_for_user_only', false)
                && get(item, 'book.available_for_user_till', false));
            });

            if (isExistUserAvailableBook) {
              haveBooksAvailableForUserOnly = true;
            }

            this.setState({
              totalBooksCounter,
              latestBooks,
              counters,
              haveBooksAvailableForUserOnly,
            });
          }
        }
        ;
      });
  }

  fetchLatestUserBooks(userId) {
    const url = `/api/bookuserlist/?user=${userId}&order_by=-changed_at&limit=10`;
    return fetchQuery(url, { apiVersion: 6 });
  }

  fetchLatestBookshelves(userId) {
    const url = `/api/bookshelf/?user=${userId}`;
    return fetchQuery(url, { apiVersion: 3 })
      .then(({ data }) => {
        if (this._isMounted) {
          this.setState({
            bookshelves: data.objects,
          });
        }
      });
  }

  onChangeStatus(value) {
    const { isExistUploadedBooks, selectedType } = this.state;
    let newCouners = { ...this.state.counters, ...{} };
    if (value.textValue === 'uploads' && isExistUploadedBooks) {
      newCouners['text'] = { ...newCouners['text'], uploads: 0 };
    }

    if (value.textValue === 'have_time_to_read') {
      ga('send', 'event', {
        eventCategory: 'MyBooks',
        eventAction: 'OpenExpireSoonList',
        eventLabel: selectedType === 'text' ? 'Books' : 'Audio',
      });
    }

    this.setState({ selectedStatus: value.value, counters: newCouners });
  }

  shelveDialog() {
    return (
      <ModalDialog onClose={() => {
        this.closeModalWindow();
      }} dialog={
        {
          id: '1',
          extraClassName: 'jest-shelveDialog-window',
          emojiIcon: '',
          title: '',
          content:
            <NewShelveDialog
              {...this.props}
              gaEventLabel={'MyBooks'}
              closeModal={this.closeModalWindow} />,
        }
      } />
    );
  }

  closeModalWindow() {
    const url = `/api/bookshelf/?user=${this.state.userId}`;
    fetchQuery(url, { apiVersion: 3 })
      .then(({ data }) => {
        this.setState({
          bookshelves: data.objects,
        });
      }).then(() => {
        this.setState({ modalWindow: false });
      });
  }

  openModalWindow() {
    this.setState({ modalWindow: true });
  }

  render() {
    const { totalBooksCounter, latestBooks, userId, selectedStatus, selectedType, bookshelves, counters } = this.state;
    const { user } = this.props;
    const optionsForSelect = selectedType === 'text' ? TEXT_BOOKS_FILTER : AUDIO_BOOKS_FILTER;
    let valueForSelect = optionsForSelect.find((item) => (item.value == selectedStatus));
    if (selectedStatus === 4 && selectedType === 'audio') {
      valueForSelect = optionsForSelect.find((item) => (item.value == 1));
    }
    let isHaveRentedAudioBooks = false;
    if (latestBooks) {
      isHaveRentedAudioBooks = !!latestBooks.filter((item) => (item.type === 'audio' && item.is_rented));
    }

    const selectedStatusBooksCount = get(counters, `${selectedType}.${valueForSelect.textValue}`, null);
    const isAudioBooksAvailable =
      isFuture(get(this.props, 'user.subscription_audio_active_till', null))
      || isHaveRentedAudioBooks;
    const bookshelvesLength = get(bookshelves, 'length', 0);
    const modalWindow = this.shelveDialog();

    if (!user) {
      return <Redirect to={URLS.dashboard} />;
    }

    return (
      <div className={classNames('backgroundContainer', `themeGrey`)}>
        <div className="section">
          <h1 className={styles.title}>
            Мои книги
            {totalBooksCounter > 0 && (
              <Link to="books" className={styles.titleLink}>
                Все {totalBooksCounter}
                <span className="shortArrow" />
              </Link>
            )}
          </h1>
        </div>
        <div className={styles.orange}>
          <div className={styles.latestBooksContainer}>
            <div className={styles.latestBooksWrapper}>
              {!latestBooks && <SpinnerLoader />}
              {latestBooks && (
                <React.Fragment>
                  {totalBooksCounter <= 0
                    ? this.renderEmptyLatestBooks()
                    : this.renderLatestBooks(latestBooks)
                  }
                </React.Fragment>
              )}
            </div>
          </div>
          {bookshelvesLength === 0 ?
            <div className={styles.shelfSection}>
              <div className={styles.shelfWrapper}>
                <span className={styles.shelfText}>У вас нет ни одной полки, и самое время создать первую.</span>
                <Button
                  theme="primary"
                  extraClassName={styles.shelfButton}
                  handleClick={() => this.openModalWindow()}>
                  Создать полку
                </Button>
              </div>
            </div>
            : null}
          {this.state.modalWindow ? modalWindow : null}
          <div className="section">
            {bookshelvesLength > 0 && this.renderUserBooksheves(bookshelves, userId)}
            <Link to={`/profile/${userId}/bookmark/`} className={styles.bookmarkMobile}>
              <StarIcon extraClassName={styles.icon} />
              <div className={styles.bookmarkText}>Избранное</div>
            </Link>
            <div className={styles.typeSelector}>
              <button className={classNames(
                styles.typeSelectorItem,
                { [styles.typeSelectorActive]: selectedType === 'text' },
                'jest-select-text',
              )}
              onClick={() => this.setState({ selectedType: 'text' })}>
                Книги
              </button>
              {isAudioBooksAvailable && (
                <button className={classNames(
                  styles.typeSelectorItem,
                  { [styles.typeSelectorActive]: selectedType === 'audio' },
                  'jest-select-audio',
                )}
                onClick={() => this.setState({ selectedType: 'audio' })}>
                  Аудиокниги
                </button>
              )}
              <Link to={`/profile/${userId}/bookmark/`} className={styles.bookmark}>
                <StarIcon extraClassName={styles.icon} />
                <div className={styles.bookmarkText}>Избранное</div>
              </Link>
            </div>
          </div>
        </div>
        <div className="section">
          <Select
            name="statusText"
            options={optionsForSelect}
            value={valueForSelect}
            components={{ Option: StatusOption, ValueContainer: StatusValueContainer }}
            extraClassName={styles.statusSelector}
            width="100%"
            onChange={(value) => this.onChangeStatus(value)} />
          <div className={styles.counter}>
            {selectedStatusBooksCount > 0 && (
              <React.Fragment>
                {selectedStatusBooksCount}&nbsp;
                {selectedType === 'audio' ? 'aудио' : null}
                {pluralize(selectedStatusBooksCount, 'книга', 'книги', 'книг')}
              </React.Fragment>
            )}
          </div>
        </div>
        {selectedStatusBooksCount === null
          ? <SpinnerLoader />
          : (
            <React.Fragment>
              {(selectedStatusBooksCount > 0 || selectedStatus === 4)
                ? <UserProfileViewBooks userId={userId} status={selectedStatus} type={selectedType} />
                : <UserProfileViewBooksEmpty status={selectedStatus} type={selectedType} />
              }
            </React.Fragment>
          )
        }
      </div>
    );
  }

  renderEmptyLatestBooks() {
    return (
      <div className={styles.noBooks}>
        <div className={styles.fakeCovers}>
          {[...Array(10)].map((item, idx) => (
            <div className={styles.fakeCoversItem} key={`fakeCover${idx}`} />
          ))}
        </div>
        <div className={styles.noBooksTitle}>Здесь будут ваши книги</div>
        <Link
          to="/catalog/"
          className={styles.noBooksLink}>
          Выбрать первую книгу
        </Link>
      </div>
    );
  }

  handleBookClick(book) {
    if (get(book, 'available_for_user_only', false)) {
      const isAudio = book.type === 'audio';
      ga('send', 'event', {
        eventCategory: 'MyBooks',
        eventAction: 'OpenExpireSoonBook',
        eventLabel: isAudio ? 'Audio' : 'Books',
      });
    }
  }

  renderLatestBooks(bookList) {
    return (
      <div className="jest-latest-user-books">
        <div className={styles.carouselContainer}>
          <ContentCarousel>
            {bookList.map((userBook) => {
              const isAudioBook = get(userBook, 'book.type', null) === 'audio';

              // Книга доступна только для конкретного пользователя
              const isAvailableOnlyUser = !!get(userBook, 'book.available_for_user_only', false);

              // Книга не доступна для пользователя
              const isNotAvailableForUser = !get(userBook, 'book.available_for_user', false)
                && !get(userBook, 'book.available', false)
                && !get(userBook, 'book.is_rented', false);

              return (
                <div key={userBook.book.id} className={styles.item}>
                  <BookCover book={new Book(userBook.book)}
                    width={124}
                    isAudioBook={isAudioBook}
                    linkCallback={this.handleBookClick}
                    isNotAvailableForUser={isNotAvailableForUser}
                    isAvailableOnlyUser={isAvailableOnlyUser}
                    height={userBook.book.type === 'audio' ? 124 : 196} />
                </div>
              );
            })}
          </ContentCarousel>
        </div>
      </div>
    );
  }

  renderUserBooksheves(bookshelves, userId) {
    const bookshelfUrl = `/profile/${userId}/bookshelves/`;
    return (
      <div className={styles.bookshelves}>
        <h2 className={styles.bookshelvesTitle}>Мои полки</h2>
        <Link to={bookshelfUrl} className={styles.bookshelvesLink}>
          <span className={styles.bookshelvesLinkText}>Все {bookshelves.length}</span>
          <span className="arrowRight" />
        </Link>
        <UserBookshelvesList
          bookshelves={bookshelves}
          userId={userId} />
      </div>
    );
  };
}

UserProfileView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      userId: PropTypes.string.isRequired,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserProfileView);
